import { RefObject, useCallback, useState } from 'react';

import { useIsomorphicLayoutEffect } from '@r1-frontend/shared/hooks/useIsomorphicLayoutEffect';

interface IResult {
    height: number | undefined,
    width: number | undefined,
}

export const useResizeObserver = (
    ref: RefObject<HTMLElement>,
    callback?: (entry: DOMRectReadOnly) => void,
): IResult => {
    const [width, setWidth] = useState<number>();
    const [height, setHeight] = useState<number>();

    const handleResize = useCallback(
        (entries) => {
            if (!Array.isArray(entries)) {
                return;
            }

            const entry = entries[0];
            setWidth(entry.contentRect.width);
            setHeight(entry.contentRect.height);

            if (callback) {
                callback(entry.contentRect);
            }
        },
        [callback],
    );

    useIsomorphicLayoutEffect(() => {
        if (!ref.current) {
            return;
        }

        let RO: ResizeObserver | null = new ResizeObserver((entries) => window.requestAnimationFrame(() => handleResize(entries)));
        RO.observe(ref.current);

        return () => {
            RO?.disconnect();
            RO = null;
        };
    }, [ref]);

    return { width, height };
};
